import { sliders } from './sliders.js'
import { templates } from './../templates.js'

//template files
import templateItemAccomodation from './../../template-parts/accomodation/itemAccomodation.js';
import * as templatePagination from './../../template-parts/accomodation/pagination.js';

var accomodations = {
  options: {
    ajax_url: sikmoVars.ajax_url,
    limit_per_page: 12,
    current_page: 1,
    pagination_delta: 2, // Number of pages to show before and after the current page in Pagination
    list_accomodations: null,
    edit_mode: false,
    only_current_user: false,
    only_active: false,
    only_unactive: false,
    leaflet_map_object: null,
    current_url: null,
    previous_url: null,
    allow_rendering: false,
    post_type: null,
  },

  selectors: {
    el_list_filters: ".js-accomodations-input-filter-terms",
    el_list_filters_service_types: ".js-accomodations-input-filter-service-types",
    el_list_filters_allow_only_one_value: ".js-accomodations-input-filter-allow-only-one-value",
    el_list_filters_hide_group: ".js-accomodations-input-filter-hide-group",
    el_list_accomodation: "#js-accomodations-list",
    el_list_pagination: "#js-accomodations-pagination",

    //Main Filters
    el_input_country: "#js-accomodations-input-filter-where",
    el_input_date_from: "#js-accomodations-input-filter-date-from",
    el_input_date_to: "#js-accomodations-input-filter-date-to",
    el_input_top_people: "#js-accomodations-input-filter-people",
    el_input_top_button_submit: "#js-accomodations-input-filter-submit",
    el_input_top_button_show_filters: ".js-accomodations-input-filters-show",
    el_input_top_button_show_and_reset_filters: ".js-accomodations-input-filters-show-and-reset",
    el_input_top_button_filters: ".js-accomodations-button-filters",

    //Error messages
    el_message_not_found: "#js-accomodations-message-not-found",
    el_message_error: "#js-accomodations-message-error",

    //Loading spinner
    el_loading: "#js-accomodations-loading",

    //Buttons
    el_button_show_more: "#js-accomodations-button-show-more",
    el_buttons_order: ".js-accomodations-order-buttons",

    //Other filters
    el_input_bedrooms: ".js-accomodations-input-bedrooms",
    el_input_beds_single: ".js-accomodations-input-beds-single",
    el_input_beds_double: ".js-accomodations-input-beds-double",
    el_input_beds_extra: ".js-accomodations-input-beds-extra",
    el_input_beds_extra_common: ".js-accomodations-input-beds-extra-common",
    el_input_kitchens: ".js-accomodations-input-kitchens",
    el_input_baths: ".js-accomodations-input-baths",
    el_input_balconies: ".js-accomodations-input-balconies",
    el_input_terraces: ".js-accomodations-input-terraces",

    //Distances
    el_input_distance_center: ".js-accomodations-input-distance-center",
    el_input_distance_beach: ".js-accomodations-input-distance-beach",
    el_input_distance_airport: ".js-accomodations-input-distance-airport",

    //Map
    el_map_id: "js-accomodations-map",
    el_map_button: ".js-accomodations-map-button",
    el_content: ".js-accomodations-content",
  },

  init: function () {
    const self = this;

    //Exists?
    if (jQuery(self.selectors.el_list_accomodation).length === 0) {
      return;
    }

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    //set current page (from url query)
    self.options.current_page = parseInt(jQuery(self.selectors.el_list_accomodation).data("current-page"));

    if (self.options.current_page == -1) {
      self.options.current_page = 1;
      self.options.limit_per_page = 99999; //unlimited per page
    }

    if (self.options.current_page == 0) self.options.current_page = 1;

    //set filter to accomodations by current logged user only
    self.options.only_current_user = (jQuery(self.selectors.el_list_accomodation).data("only-current-user") == true) ? true : false;

    //set filter to only active accomodations (only for edit mode)
    self.options.only_active = (jQuery(self.selectors.el_list_accomodation).data("only-active") == true) ? true : false;

    //set filter to only active accomodations (only for edit mode)
    self.options.only_unactive = (jQuery(self.selectors.el_list_accomodation).data("only-unactive") == true) ? true : false;

    //set edit mode
    if (self.options.only_current_user) self.options.edit_mode = (jQuery(self.selectors.el_list_accomodation).data("edit-mode") == true) ? true : false;

    self.options.post_type = jQuery(self.selectors.el_list_accomodation).data("post-type") || "accomodation";

    //change URL watcher
    self.startUrlChangeChecker();

    //events
    self.tagsChanged();
    self.searchButtonClicked();
    self.showFilterClicked();
    self.showAndResetFilterClicked();
    self.showMoreButtonClicked();
    self.changeOrderButtonClicked();
    self.distancesChanged();
    self.otherFiltersChanged();
    self.resetFilterClicked();
    self.initAllowOnlyOneValue();
    self.serviceTypeChanged();

    self.getAllAccomodations(); //init get all accomodations

    //Map
    self.mapButtonClicked();
  },

  tagsChanged: function () {
    const self = this;
    jQuery(self.selectors.el_list_filters + " input[type='checkbox']").on("change", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  },

  serviceTypeChanged: function () {
    const self = this;
    jQuery(self.selectors.el_list_filters_service_types + " input[type='checkbox']").on("change", function () {
      self.resetFilters(true);
      self.hideUnhideFilterGroups();
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  },

  initAllowOnlyOneValue: function () {
    const self = this;

    jQuery(self.selectors.el_list_filters_allow_only_one_value + " input[type='checkbox']").on("change", function () {
      if (jQuery(this).prop("checked")) {
        //uncheck all other checkboxes
        let term_id = jQuery(this).data("term-id");
        let type = jQuery(this).data("type");

        jQuery(this).closest("ul").find("input[type='checkbox']:not([data-term-id='" + term_id + "']):not([data-type='" + type + "'])").prop("checked", false);

        //change current page to 1 and re-render
        self.changeCurrentPage(1);
      }
    });
  },

  distancesChanged: function () {
    const self = this;

    jQuery(self.selectors.el_input_distance_center).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });

    jQuery(self.selectors.el_input_distance_beach).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });

    jQuery(self.selectors.el_input_distance_airport).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  },

  otherFiltersChanged: function () {
    const self = this;
  
    jQuery(self.selectors.el_input_bedrooms).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_beds_single).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_beds_double).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_beds_extra).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_beds_extra_common).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_kitchens).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_baths).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_balconies).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  
    jQuery(self.selectors.el_input_terraces).on("input", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  },

  searchButtonClicked: function () {
    const self = this;
    jQuery(self.selectors.el_input_top_button_submit).on("click", function () {
      //change current page to 1 and re-render
      self.changeCurrentPage(1);
    });
  },

  mapButtonClicked: function () {
    const self = this;
    jQuery(self.selectors.el_map_button).on("click", function (event) {
      event.preventDefault();
      self.leafletToggleMap();
    });
  },

  showFilterClicked: function () {
    const self = this;
    jQuery(self.selectors.el_input_top_button_show_filters).on("click", function (event) {
      event.preventDefault();
      jQuery(".aside-filter").toggleClass("aside-filter--open");
    });
  },

  showAndResetFilterClicked: function () {
    const self = this;
    jQuery(self.selectors.el_input_top_button_show_and_reset_filters).on("click", function (event) {
      event.preventDefault();
      jQuery(".aside-filter").toggleClass("aside-filter--open");
      self.resetFilters();
    });
  },

  showMoreButtonClicked: function () {
    const self = this;
    jQuery(self.selectors.el_button_show_more).on("click", function (event) {
      event.preventDefault();
      //change current page and re-render (without set display:none to all items)
      self.changeCurrentPage(self.options.current_page + 1, true);
    });
  },

  changeOrderButtonClicked: function () {
    const self = this;
    jQuery(self.selectors.el_buttons_order).find("a").on("click", function (event) {
      event.preventDefault();

      jQuery(self.selectors.el_buttons_order).find("li").removeClass("active");
      jQuery(this).parent().addClass("active");

      self.orderAccomodations(jQuery(this).data("order"));
    });
  },

  orderAccomodations: function (type = "") {
    const self = this;

    if (!self.options.list_accomodations || self.options.list_accomodations.length === 0) {
      return;
    }

    // First, sort the array
    if (type === "price_asc") {
      self.options.list_accomodations.sort(function (a, b) {
        return parseInt(a[13]) - parseInt(b[13]); // a[13] is price_raw
      });
    } else if (type === "price_desc") {
      self.options.list_accomodations.sort(function (a, b) {
        return parseInt(b[13]) - parseInt(a[13]); // b[13] is price_raw
      });
    } else if (type === "review_desc") {
      self.options.list_accomodations.sort(function (a, b) {
        return parseFloat(b[11]) - parseFloat(a[11]); // b[11] is stars_raw
      });
    } else {
      return;
    }

    // Now sort HTML DOM elements based on the sorted array order
    const container = jQuery(self.selectors.el_list_accomodation);
    const sortedElements = [];
    
    self.options.list_accomodations.forEach(function(item) {
      const elementId = item[0]; // ID is at index 0
      const element = container.find(`li[data-id='${elementId}']`);
      if (element.length) {
        sortedElements.push(element.detach()); // Remove from DOM and add to sorted array
      }
    });
    
    // Append all sorted elements back to container
    container.empty(); // Clear container first
    sortedElements.forEach(function(element) {
      container.append(element);
    });

    //re-render
    self.changeCurrentPage(1);
  },

  renderAccomodations: function (only_append = false) {
    const self = this;

    if (!self.options.allow_rendering) {
      return;
    }

    //
    //Actual selected filters
    //

    //Tags
    let filter_selected_tags = {};
    let filter_selected_tags_count = 0;
    jQuery(self.selectors.el_list_filters + " input[type='checkbox']").each(function (index, element) {
      let is_checked = jQuery(element).prop("checked");
      filter_selected_tags[jQuery(element).data("term-id")] = is_checked;
      if (is_checked) filter_selected_tags_count++;
    });

    //set new query vars for tags
    let array_filter_selected_tags = Object.keys(filter_selected_tags).filter(key => filter_selected_tags[key]).map(Number);
    self.updateQueryStringParam('tags[]', array_filter_selected_tags);

    //Filter service types
    let filter_service_type = '';
    jQuery(self.selectors.el_list_filters_service_types + " input[type='checkbox']").each(function (index, element) {
      let is_checked = jQuery(element).prop("checked");
      if (is_checked) {
        filter_service_type = jQuery(element).data("type");
      }
    });

    self.updateQueryStringParam('type', filter_service_type);

    //update count on filter button (mobile device only)
    jQuery(self.selectors.el_input_top_button_filters).find(".count").text(" (" + (filter_selected_tags_count + (filter_service_type ? 1 : 0)) + ")");

    //Filter bedrooms
    let filter_bedrooms = parseInt(jQuery(self.selectors.el_input_bedrooms).val());
    if (isNaN(filter_bedrooms) || filter_bedrooms < 0) filter_bedrooms = 0;

    //set new query param for bedrooms
    if (filter_bedrooms !== 0) {
      self.updateQueryStringParam('bedrooms', filter_bedrooms);
    } else {
      self.updateQueryStringParam('bedrooms', '');
    }

    //Filter single beds
    let filter_beds_single = parseInt(jQuery(self.selectors.el_input_beds_single).val());
    if (isNaN(filter_beds_single) || filter_beds_single < 0) filter_beds_single = 0;

    //set new query param for single beds
    if (filter_beds_single !== 0) {
      self.updateQueryStringParam('beds_single', filter_beds_single);
    } else {
      self.updateQueryStringParam('beds_single', '');
    }

    //Filter double beds
    let filter_beds_double = parseInt(jQuery(self.selectors.el_input_beds_double).val());
    if (isNaN(filter_beds_double) || filter_beds_double < 0) filter_beds_double = 0;

    //set new query param for double beds
    if (filter_beds_double !== 0) {
      self.updateQueryStringParam('beds_double', filter_beds_double);
    } else {
      self.updateQueryStringParam('beds_double', '');
    }

    //Filter extra beds
    let filter_beds_extra = parseInt(jQuery(self.selectors.el_input_beds_extra).val());
    if (isNaN(filter_beds_extra) || filter_beds_extra < 0) filter_beds_extra = 0;

    //set new query param for extra beds
    if (filter_beds_extra !== 0) {
      self.updateQueryStringParam('beds_extra', filter_beds_extra);
    } else {
      self.updateQueryStringParam('beds_extra', '');
    }

    //Filter extra common beds
    let filter_beds_extra_common = parseInt(jQuery(self.selectors.el_input_beds_extra_common).val());
    if (isNaN(filter_beds_extra_common) || filter_beds_extra_common < 0) filter_beds_extra_common = 0;

    //set new query param for extra common beds
    if (filter_beds_extra_common !== 0) {
      self.updateQueryStringParam('beds_extra_common', filter_beds_extra_common);
    } else {
      self.updateQueryStringParam('beds_extra_common', '');
    }

    //Filter kitchens
    let filter_kitchens = parseInt(jQuery(self.selectors.el_input_kitchens).val());
    if (isNaN(filter_kitchens) || filter_kitchens < 0) filter_kitchens = 0;

    //set new query param for kitchens
    if (filter_kitchens !== 0) {
      self.updateQueryStringParam('kitchens', filter_kitchens);
    } else {
      self.updateQueryStringParam('kitchens', '');
    }

    //Filter baths
    let filter_baths = parseInt(jQuery(self.selectors.el_input_baths).val());
    if (isNaN(filter_baths) || filter_baths < 0) filter_baths = 0;
    
    //set new query param for baths
    if (filter_baths !== 0) {
      self.updateQueryStringParam('baths', filter_baths);
    } else {
      self.updateQueryStringParam('baths', '');
    }

    //Filter balconies
    let filter_balconies = parseInt(jQuery(self.selectors.el_input_balconies).val());
    if (isNaN(filter_balconies) || filter_balconies < 0) filter_balconies = 0;
    
    //set new query param for balconies
    if (filter_balconies !== 0) {
      self.updateQueryStringParam('balconies', filter_balconies);
    } else {
      self.updateQueryStringParam('balconies', '');
    }

    //Filter terraces
    let filter_terraces = parseInt(jQuery(self.selectors.el_input_terraces).val());
    if (isNaN(filter_terraces) || filter_terraces < 0) filter_terraces = 0;

    //set new query param for terraces
    if (filter_terraces !== 0) {
      self.updateQueryStringParam('terraces', filter_terraces);
    } else {
      self.updateQueryStringParam('terraces', '');
    }

    //Distance center
    let filter_distance_center = parseFloat(jQuery(self.selectors.el_input_distance_center).val());
    if (isNaN(filter_distance_center) || filter_distance_center < 0) filter_distance_center = 0;

    //set new query car for distance center
    if (filter_distance_center !== 0) {
      self.updateQueryStringParam('distance_center', filter_distance_center);
    } else {
      self.updateQueryStringParam('distance_center', '');
    }

    //Distance beach
    let filter_distance_beach = parseFloat(jQuery(self.selectors.el_input_distance_beach).val());
    if (isNaN(filter_distance_beach) || filter_distance_beach < 0) filter_distance_beach = 0;

    //set new query car for distance beach
    if (filter_distance_beach !== 0) {
      self.updateQueryStringParam('distance_beach', filter_distance_beach);
    } else {
      self.updateQueryStringParam('distance_beach', '');
    }

    //Distance airport
    let filter_distance_airport = parseFloat(jQuery(self.selectors.el_input_distance_airport).val());
    if (isNaN(filter_distance_airport) || filter_distance_airport < 0) filter_distance_airport = 0;

    //set new query car for distance airport
    if (filter_distance_airport !== 0) {
      self.updateQueryStringParam('distance_airport', filter_distance_airport);
    } else {
      self.updateQueryStringParam('distance_airport', '');
    }

    //Country
    let filter_country = jQuery(self.selectors.el_input_country).val();
    self.updateQueryStringParam('country', filter_country);

    //Date from
    let filter_date_from = moment(jQuery(self.selectors.el_input_date_from).val(), "DD.MM.YYYY"); //moment object
    if (filter_date_from.isValid()) {
      self.updateQueryStringParam('date_from', filter_date_from.format('DD.MM.YYYY'));
    } else {
      self.updateQueryStringParam('date_from', '');
    }

    //Date to
    let filter_date_to = moment(jQuery(self.selectors.el_input_date_to).val(), "DD.MM.YYYY"); //moment object
    if (filter_date_to.isValid()) {
      self.updateQueryStringParam('date_to', filter_date_to.format('DD.MM.YYYY'));
    } else {
      self.updateQueryStringParam('date_to', '');
    }

    //Maximum persons
    let filter_max_persons = parseInt(jQuery(self.selectors.el_input_top_people).val());
    if (isNaN(filter_max_persons) || filter_max_persons < 0) filter_max_persons = 0;

    //set new query vars for persons
    if (filter_max_persons !== 0) {
      self.updateQueryStringParam('persons', filter_max_persons);
    } else {
      self.updateQueryStringParam('persons', '');
    }

    //display none to all items in list
    if (!only_append) {
      jQuery(self.selectors.el_list_accomodation + " li").removeClass("show");

      if (self.options.list_accomodations != null) {
        self.options.list_accomodations.forEach((element) => {
          element.is_showing = false;
        });
      }
    }

    //loop all items and on filtered items set display:block (class=show)
    let total_items = 0;
    
    if (self.options.list_accomodations != null) {
      for (const element of self.options.list_accomodations) {
        let is_country_selected = (typeof filter_country == "undefined" || filter_country == "" || element[9] == filter_country);
        
        // is_tag_selected working as AND condition
        let is_tag_selected = Object.keys(filter_selected_tags).every(key => {
          return !filter_selected_tags[key] || element[4].includes(parseInt(key));
        });

        let is_match_maximum_persons = (element[5] === 0 || filter_max_persons === 0 || element[5] >= filter_max_persons);

        // Is from-to date in filter available?
        let is_match_available_date = true;
        if (element[14].length > 0 && filter_date_from.isValid() && filter_date_to.isValid()) {
          let temp_moment_object = moment(filter_date_from); // Clone the start date to avoid modifying it

          //loop day by day in current selected filter date from-to, and check if every day is available
          while (temp_moment_object.isSameOrBefore(filter_date_to, 'day')) {
            if (element[14].includes(parseInt(temp_moment_object.format("YYYYMMDD")))) {
              is_match_available_date = false;
              break;
            }

            temp_moment_object.add(1, 'days'); // Increment the date by one day
          }
        }

        //Is distance center match?
        let is_match_distance_center = (filter_distance_center === 0 || element[16] <= filter_distance_center);

        //Is distance beach match?
        let is_match_distance_beach = (filter_distance_beach === 0 || element[17] <= filter_distance_beach);

        //Is distance airport match?
        let is_match_distance_airport = (filter_distance_airport === 0 || element[18] <= filter_distance_airport);

        //Is bedrooms match?
        let is_match_bedrooms = (filter_bedrooms === 0 || element[21] >= filter_bedrooms);

        //Is single beds match?
        let is_match_beds_single = (filter_beds_single === 0 || element[22] >= filter_beds_single);

        //Is double beds match?
        let is_match_beds_double = (filter_beds_double === 0 || element[23] >= filter_beds_double);

        //Is extra beds match?
        let is_match_beds_extra = (filter_beds_extra === 0 || element[24] >= filter_beds_extra);

        //Is extra common beds match?
        let is_match_beds_extra_common = (filter_beds_extra_common === 0 || element[25] >= filter_beds_extra_common);

        //Is kitchens match?
        let is_match_kitchens = (filter_kitchens === 0 || element[26] >= filter_kitchens);

        //Is baths match?
        let is_match_baths = (filter_baths === 0 || element[27] >= filter_baths);

        //Is balconies match?
        let is_match_balconies = (filter_balconies === 0 || element[28] >= filter_balconies);

        //Is terraces match?
        let is_match_terraces = (filter_terraces === 0 || element[29] >= filter_terraces);

        //Is type match?
        let is_type_match = (filter_service_type === "" || element[31] === filter_service_type);

        if (
          is_country_selected
          && is_tag_selected
          && is_match_maximum_persons
          && is_match_available_date
          && is_match_distance_center
          && is_match_distance_beach
          && is_match_distance_airport
          && is_match_bedrooms
          && is_match_beds_single
          && is_match_beds_double
          && is_match_beds_extra
          && is_match_beds_extra_common
          && is_match_kitchens
          && is_match_baths
          && is_match_balconies
          && is_match_terraces
          && is_type_match
        ) {
          total_items++;
          if (total_items <= self.options.current_page * self.options.limit_per_page && total_items > (self.options.current_page - 1) * self.options.limit_per_page) { //pagination limit
            jQuery(self.selectors.el_list_accomodation + " li[data-id='" + element[0] + "']").addClass("show"); //we can safely show this item
            element.is_showing = true;
          }
        }
      }
    }

    //init sliders for all items (With love for performance: it destroy all current slider instances and create only for class .show)
    sliders.accomodationsItemSlider();

    if (total_items === 0) {
      jQuery(self.selectors.el_message_not_found).addClass("show");
    } else {
      jQuery(self.selectors.el_message_not_found).removeClass("show");
    }

    //hide loading spinner
    jQuery(self.selectors.el_loading).addClass("d-none");

    //If specified page (in query var) exceeded limit, fix it
    if (total_items > self.options.limit_per_page && total_items <= (self.options.current_page * self.options.limit_per_page - self.options.limit_per_page)) {
      //change to last page
      self.changeCurrentPage(Math.ceil(total_items / self.options.limit_per_page));
    }

    //Make pagination
    self.renderPagination(total_items);

    //Rerender leaflat Map markers
    self.leafletRenderMarkers();
  },

  getAllAccomodations: function () {
    const self = this;

    jQuery.ajax({
      dataType: "json",
      url: self.options.ajax_url,
      data: {
        action: "accomodations",
        accomodations_action: "get_all",
        only_current_user: self.options.only_current_user,
        only_active: self.options.only_active,
        only_unactive: self.options.only_unactive,
        post_type: self.options.post_type,
      },
    })
      .done(function (data) {
        self.options.list_accomodations = data;
        self.options.allow_rendering = true;

        data.forEach((val, index) => {

          let gallery_items = "";
          let nav_buttons = "";
          val[6].forEach(element => {
            gallery_items += templates.renderTemplate(templateItemAccomodation.gallery_item, { img: element });
            nav_buttons += '<span></span>';
          });

          //Tags
          let tag = "";
          if (val[7] == "top") {
            tag = templates.renderTemplate(templateItemAccomodation.tag, { tag_img: sikmoVars.icons.fire, tag: sikmoVars.translation.top });
          }

          //Extra tags in user edit listing
          let extra_tags = "";
          if (self.options.edit_mode) {
            //console.log(val[15]);
            extra_tags += templates.renderTemplate(templateItemAccomodation.extra_tag, {
              name_for_users: val[15].name_for_users,
              frontend_color_class: val[15].frontend_color_class,
              frontend_icon: (val[15].frontend_icon != "" ? '<img src="'+ sikmoVars.theme_url + '/' + val[15].frontend_icon +'">' : ""),
            });

            if (val[15].show_on_frontend) {
              extra_tags += templates.renderTemplate(templateItemAccomodation.extra_tag_showing_on);
            } else {
              extra_tags += templates.renderTemplate(templateItemAccomodation.extra_tag_showing_off);
            }

            if (val[15].is_paid) {
              extra_tags += templates.renderTemplate(templateItemAccomodation.extra_tag_paid_on);
            } else {
              extra_tags += templates.renderTemplate(templateItemAccomodation.extra_tag_paid_off);
            }
          }

          let stars = "";
          if (val[11] !== 0) {
            stars = templates.renderTemplate(templateItemAccomodation.stars, { stars: val[11] });
          }

          const render_data = {
            id: val[0],
            url: val[1],
            name: val[2],
            author: val[3],
            gallery_items: gallery_items,
            tag: tag,
            price: val[8],
            icon_arrow: sikmoVars.icons.arrow_left_white,
            top: val[10],
            stars: stars,
            stars_raw: val[11],
            region: val[12],
            country_name: val[30],
            icon_bed: sikmoVars.icons.bed,
            persons: val[5],
            price_raw: val[13],
            nav_buttons: nav_buttons,
            extra_tags: extra_tags,
          };

          let template_list_item = templateItemAccomodation.list_item;
          if (val[31] !== "accomodation") {
            template_list_item = templateItemAccomodation.list_item_service;
          }

          //append into HTML
          jQuery(self.selectors.el_list_accomodation).append(templates.renderTemplate(template_list_item, render_data));
        });

        //the first time render
        self.renderAccomodations();

        //the first sort
        self.orderAccomodations("price_asc");
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        jQuery(self.selectors.el_message_error).addClass("show");
      });
  },

  renderPagination: function (items_count) {
    const self = this;

    const max_count = Math.ceil(items_count / self.options.limit_per_page);
    const pagination = [];
    const left = self.options.current_page - self.options.pagination_delta;
    const right = self.options.current_page + self.options.pagination_delta;

    for (let i = 1; i <= max_count; i++) {
      if (i === 1 || i === max_count || (i >= left && i <= right)) {
        pagination.push(i);
      } else if (i === left - 1 || i === right + 1) {
        pagination.push('...');
      }
    }

    let html = '';

    if (pagination.length > 0) {
      for (const page of pagination) {
        if (page === self.options.current_page) {
          html += templates.renderTemplate(templatePagination.page_active, { page: page });
        } else if (page === "...") {
          html += templates.renderTemplate(templatePagination.page_dots);
        } else {
          html += templates.renderTemplate(templatePagination.page_clickable, { page: page });
        }
      }
    }

    jQuery(self.selectors.el_list_pagination).html(html);
    
    // show/hide pagination
    if (pagination.length < 2) {
      jQuery(self.selectors.el_list_pagination).addClass("d-none");
    } else {
      jQuery(self.selectors.el_list_pagination).removeClass("d-none");
    }

    //new pagination events
    self.setPaginationEvents();

    //render show more button
    self.renderShowMoreButton(items_count);
  },

  setPaginationEvents: function () {
    const self = this;

    jQuery(self.selectors.el_list_pagination + " a").on("click", function (event) {
      event.preventDefault();

      let page = parseInt(jQuery(this).data("page"));

      //scroll up
      jQuery('html, body').animate({ scrollTop: jQuery(self.selectors.el_list_accomodation).offset().top - 120 }, 0);

      self.changeCurrentPage(page);
    });
  },

  renderShowMoreButton: function (items_count) {
    const self = this;

    const maximum_items_to_show = self.options.current_page * self.options.limit_per_page;
    const el_show_more_button = jQuery(self.selectors.el_button_show_more);

    if (maximum_items_to_show >= items_count) {
      el_show_more_button.addClass("hide");
    } else {
      el_show_more_button.removeClass("hide").find(".number").text(self.options.limit_per_page);
    }
  },

  changeCurrentPage: function (page, only_append = false) {
    const self = this;

    //set new page into options
    self.options.current_page = page;
    //update URL query
    self.updateQueryStringParam('page', page);
    //render again
    self.renderAccomodations(only_append);
  },

  //value = array or string
  updateQueryStringParam: function (key, value) {
    self = this;

    if (self.options.current_url === null) {
      self.options.current_url = window.location.href;
    }

    let url = new URL(self.options.current_url);
  
    // Remove the key if value is undefined, null, or an empty string
    if (value === undefined || value === null || value === '') {
      url.searchParams.delete(key);
    } else {
      // Remove existing parameters that match the key (for handling arrays properly)
      url.searchParams.delete(key);
  
      if (Array.isArray(value)) {
        // If the value is an array, append each value with the key
        value.forEach(val => {
          url.searchParams.append(key, val);
        });
      } else {
        // If the value is not an array, set the single value for the key
        url.searchParams.set(key, value);
      }
    }

    self.options.current_url = url.toString();
  },

  startUrlChangeChecker: function () {
    const self = this;

    setInterval(function () {
      if (self.options.current_url !== self.options.previous_url && self.options.current_url !== null) {
        history.pushState({}, '', self.options.current_url);
        self.options.previous_url = self.options.current_url;
      }
    }, 500);
  },

  resetFilters: function ($only_reset_terms = false) {
    const self = this;

    if ($only_reset_terms) {
      jQuery(self.selectors.el_list_filters + " input[type='checkbox']").prop("checked", false);
      return;
    }

    // Reset all filter inputs
    jQuery(self.selectors.el_list_filters + " input[type='checkbox']").prop("checked", false);
    jQuery(self.selectors.el_list_filters_service_types + " input[type='checkbox']").prop("checked", false);
    jQuery(self.selectors.el_input_country).val('');
    jQuery(self.selectors.el_input_date_from).val('');
    jQuery(self.selectors.el_input_date_to).val('');
    jQuery(self.selectors.el_input_top_people).val('');
    jQuery(self.selectors.el_input_distance_center).val(0).trigger("input");
    jQuery(self.selectors.el_input_distance_beach).val(0).trigger("input");
    jQuery(self.selectors.el_input_distance_airport).val(0).trigger("input");
    jQuery(self.selectors.el_input_bedrooms).val(0).trigger("input");
    jQuery(self.selectors.el_input_beds_single).val(0).trigger("input");
    jQuery(self.selectors.el_input_beds_double).val(0).trigger("input");
    jQuery(self.selectors.el_input_beds_extra).val(0).trigger("input");
    jQuery(self.selectors.el_input_beds_extra_common).val(0).trigger("input");
    jQuery(self.selectors.el_input_kitchens).val(0).trigger("input");
    jQuery(self.selectors.el_input_baths).val(0).trigger("input");
    jQuery(self.selectors.el_input_balconies).val(0).trigger("input");
    jQuery(self.selectors.el_input_terraces).val(0).trigger("input");

    // Reset URL without parameters
    const url = new URL(window.location.href);
    url.search = '';
    history.pushState({}, '', url.toString());

    // Reset filter groups
    self.hideUnhideFilterGroups();

    // Reset current page and re-render
    self.changeCurrentPage(1);
  },

  resetFilterClicked: function () {
    const self = this;
    jQuery(self.selectors.el_message_not_found + " a").on("click", function (event) {
      event.preventDefault();
      self.resetFilters();
    });
  },

  leafletToggleMap: function () {
    const self = this;

    jQuery(self.selectors.el_content).toggleClass("accomodations-items__content--map-open");

    if ( self.options.leaflet_map_object !== null ) {
      return; //stop further processing because map is already initialized
    }

    const customSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" color="#f1c062" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6893 22.6825L11.6894 22.6826L11.6949 22.6851C11.8888 22.7713 12.1107 22.7715 12.3046 22.6854L12.3083 22.6837L12.3085 22.6836C12.3312 22.6732 12.3869 22.6477 12.4203 22.632C12.4913 22.5986 12.5934 22.5496 12.7221 22.4853C12.9794 22.3566 13.3438 22.1663 13.7797 21.9161C14.6496 21.4166 15.813 20.6738 16.9801 19.7012C19.2892 17.7769 21.75 14.8358 21.75 11C21.75 5.61522 17.3848 1.25 12 1.25C6.61522 1.25 2.25 5.61522 2.25 11C2.25 14.8358 4.71077 17.7769 7.01986 19.7012C8.18703 20.6738 9.35038 21.4166 10.2203 21.9161C10.6562 22.1663 11.0206 22.3566 11.2779 22.4853C11.4034 22.548 11.613 22.6466 11.6893 22.6825ZM12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7Z" fill="currentColor" /></svg>`;

    // Create a custom divIcon using the SVG
    const svgIcon = L.divIcon({
        html: customSVG,            // Insert the SVG code here
        className: 'custom-svg-icon',
        iconSize: [48, 48],         // Size matches the SVG width/height
        iconAnchor: [24, 48],       // Position the "tip" of the icon at bottom center
        popupAnchor: [0, -48]       // Optional: position popups
    });

    // Create the map
    const map = L.map(self.selectors.el_map_id);

    self.options.leaflet_map_object = map;

    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
    }).addTo(map);

    // Create all markers and calculate bounds
    const markers = [];
    self.options.list_accomodations.forEach((val, index) => {
        const marker = L.marker([val[19], val[20]], { icon: svgIcon }).addTo(map).bindPopup(
          `<a href="`+ val[1] +`"> 
          <b>`+ val[2] +`</b>
          <img src="`+ val[6][0] +`" alt="">
          <span>`+ val[8] +`</span>
          </a>`
        );

        self.options.list_accomodations[index].leaflet_marker_object = marker;

        markers.push(marker);
    });

    // Calculate bounds and fit map to bounds
    if (markers.length > 0) {
      const group = new L.featureGroup(markers);
      map.fitBounds(group.getBounds());
    }

    // Rerender (show/hide) markers according to active filters
    self.leafletRenderMarkers();
  },

  leafletRenderMarkers: function () {
    const self = this;

    if (self.options.leaflet_map_object === null) {
        return; //map is not already initialized
    }

    const visible_markers = [];

    self.options.list_accomodations.forEach((val, index) => {
        if (val.is_showing) {
            if (!self.options.leaflet_map_object.hasLayer(val.leaflet_marker_object)) {
                self.options.leaflet_map_object.addLayer(val.leaflet_marker_object);
            }
            visible_markers.push(val.leaflet_marker_object);
        } else {
            if (self.options.leaflet_map_object.hasLayer(val.leaflet_marker_object)) {
                self.options.leaflet_map_object.removeLayer(val.leaflet_marker_object);
            }
        }
    });

    // Calculate bounds and fit map to bounds
    if (visible_markers.length > 0) {
        const group = new L.featureGroup(visible_markers);
        self.options.leaflet_map_object.fitBounds(group.getBounds());
    }
  },

  hideUnhideFilterGroups: function() {
    const self = this;

    let checked = jQuery(self.selectors.el_list_filters_service_types + " input[type='checkbox']:checked");

    //hide/unhide filter groups
    jQuery(self.selectors.el_list_filters_hide_group).addClass("d-none");

    if (checked.length > 0) {
      let selected_terms_array = checked.data("terms").split(",");
      selected_terms_array.forEach(element => {
        jQuery(self.selectors.el_list_filters_hide_group + '[data-term="'+ element +'"]').removeClass("d-none");
      });
    }
  }
}

// Exporting the jQuery plugin/module
export { accomodations };